// extracted by mini-css-extract-plugin
export default {"overlay":"fI-z","bodyOpen":"gI-z","content":"hI-z","header":"iI-z","closeNoHeading":"jI-z"};